import { render, staticRenderFns } from "./Offsets.vue?vue&type=template&id=3143765a"
import script from "./Offsets.vue?vue&type=script&lang=ts"
export * from "./Offsets.vue?vue&type=script&lang=ts"
import style0 from "./Offsets.vue?vue&type=style&index=0&id=3143765a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports